/* import __COLOCATED_TEMPLATE__ from './company-size-filter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();